/* eslint-disable consistent-return */
/* eslint-disable no-nested-ternary */
export default {
  methods: {
    showImagem(data, size) {
      return data.thumbs[size] !== '' ? data.thumbs[size] : data.imagem !== '' ? data.imagem : null;
    },

    showImagePost(data) {
      return data.lg !== '' ? data.lg : data.md !== '' ? data.md : null;
    },

    nomeCategoria(categoria) {
      // console.log(categoria);
      switch (categoria) {
        case 1:
          return 'movel';
        case 2:
          return 'fixa';
        case 3:
          return 'aparelhos';
        case 4:
          return 'servicos-adicionais';
        case 5:
          return 'alavancas-comerciais';
        case 6:
          return 'institucional';
        case 7:
          return 'processo';
        case 8:
          return 'saiba';
        default:
          return 'erro';
      }
    },

    // ATRIBUIR "ID" CATEGORIA
    idCategoria(categoria) {
      // console.log(categoria);
      switch (categoria) {
        case 'movel':
          return 1;
        case 'fixa':
          return 2;
        case 'aparelhos':
          return 3;
        case 'servicos-adicionais':
          return 4;
        case 'alavancas-comerciais':
          return 5;
        case 'institucional':
          return 6;
        case 'processo':
          return 7;
        case 'saiba':
          return 8;
        default:
          return 'erro';
      }
    },
  },
};
